/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * NotFound.ts
 */

import APIError from "./APIError";

export default class NotFound extends APIError {
    constructor(message: string) {
        super("Resource introuvable", 404, message);
    }
}